import type { CopyShape } from "../../intl";

import type { ROLE_LABELS_COPY_PT_BR } from "../roles.copy";

export const ROLE_LABELS_COPY_ES_ES: CopyShape<typeof ROLE_LABELS_COPY_PT_BR> =
  {
    "org:owner": "Creator Tãmi",
    "org:admin": "Responsable de la organización",
    "org:commercial": "Mano derecha de los contratos",
    "org:planner": "Guardián de los posts",
    "org:commercial_planner": "Todoterreno oficial",
  };
